<template>
    <div>
        <div v-if="componentsWithEmptyNetPrice.length > 0" class="alert alert-warning">
            <div class="d-flex align-items-center mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="mr-2" viewBox="0 0 16 16" role="img" aria-label="Warning:">
                    <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                </svg>
                <strong class="alert-heading">Не указана себестоимость</strong>
            </div>

            <div>
                У продажи не будет считаться себестоимость, если она не указана для всех её ингредиентов.
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <table class="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th v-sort:name>Название</th>
                            <th v-sort:unit>Ед. измерения</th>
                            <th colspan="2">Себестоимость</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="component in components" :key="component.id">
                            <td class="truncate">{{ component.name }}</td>
                            <td>{{ component.unit | unit }}</td>
                            <td>
                                <template v-if="component.net_price">
                                    <div v-if="pricePerPacketLabel(component.net_price, component.unit)">
                                        {{ pricePerPacketLabel(component.net_price, component.unit) }}
                                    </div>

                                    <div v-else>
                                        {{ component.net_price }} {{ currency | currencySymbol }} за 1 {{ component.unit | unit }}
                                    </div>
                                </template>

                                <template v-else>
                                    <span class="text-muted">Не задана</span>
                                </template>
                            </td>

                            <td class="action-buttons">
                                <router-link :to="{ name: 'stocks.components.show', params: { id: component.id }}" class="btn btn-icon btn-edit" />
                                <button type="button" class="btn btn-icon btn-remove" @click.prevent="remove(component.id)" />
                            </td>
                        </tr>
                    </tbody>

                    <tfoot v-if="noOne" class="no-one">
                        <tr>
                            <td colspan="42">Вы пока не добавили ни одного ингредиента.</td>
                        </tr>
                    </tfoot>

                    <tfoot v-if="noFound" class="no-one">
                        <tr>
                            <td colspan="42">По вашему запросу не найдено ни одного ингредиента.</td>
                        </tr>
                    </tfoot>

                    <tfoot v-if="meta.last_page > 1">
                        <tr>
                            <td colspan="42">
                                <pagination :meta="meta" @input="applyFilter({ page: $event })" />
                            </td>
                        </tr>
                    </tfoot>
                </table>

                <router-view />
            </div>
        </div>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination'

import store from '@/store'
import { toastSuccess, toastError, confirm, getUsageMessage } from '@/dialogs'

import { currencySymbol, unit1000 } from '../../plugins/misc/filters'

export default {
    components: {
        Pagination
    },

    props: {
        filter: {
            type: Object,
            default: _ => ({})
        }
    },

    computed: {
        components() {
            return this.$store.getters['components/data'] || []
        },

        meta() {
            return this.$store.getters['components/meta'] || {}
        },

        isMobile() {
            return this.$store.state.isMobile
        },

        noOne() {
            return this.components.length === 0 && !this.filter.search
        },

        noFound() {
            return this.components.length === 0 && this.filter.search
        },

        currency() {
            return this.$store.state.company.profile.data.currency || null
        },

        componentsWithEmptyNetPrice() {
            return this.$store.getters['components/data'].filter(component => component.net_price === null)
        }
    },

    methods: {
        async remove(id) {
            if (!await this.$store.dispatch('components/getUsage', id)) {
                return toastError('Ошибка')
            }

            if (!await confirm('Удалить?', getUsageMessage(this.$store.state.components.usage))) {
                return
            }

            const status = await this.$store.dispatch('components/remove', id)

            if (status) {
                toastSuccess('Удалено')
            } else {
                return toastError('Ошибка')
            }
        },

        pricePerPacketLabel(net_price, unit) {
            if (unit === 1) { // Работаем только с гр - кг, мл - л
                return null
            }

            let netPrice1000 = net_price * 1000
            netPrice1000 = Math.round(netPrice1000 * 10000) / 10000

            return `${netPrice1000}` + ' ' + currencySymbol(this.currency) + ' за 1 ' + unit1000(unit)
        }
    },

    async beforeRouteEnter(to, from, next) {
        await store.dispatch('components/fetchAll', to.query)
        next()
    },

    async beforeRouteUpdate(to, from, next) {
        await store.dispatch('components/fetchAll', to.query)
        next()
    }
}
</script>
